import i18n from '@dms/i18n';

import {Field} from './primitives/Field';

export function LastServiceDatePicker() {
  return (
    <Field
      type="apiDate"
      name="lastServiceDate"
      label={i18n.t('entity.vehicle.labels.lastService')}
      tooltip={i18n.t('entity.vehicle.labels.lastServiceTooltip')}
    />
  );
}
